$('.select').on('click', '.placeholder', function() {
  var parent = $(this).closest('.select');
  if (!parent.hasClass('is-open')) {
    parent.addClass('is-open');
    $('.select.is-open').not(parent).removeClass('is-open');
  } else {
    parent.removeClass('is-open');
  }
}).on('click', 'ul>li', function() {
  var parent = $(this).closest('.select');
  parent.removeClass('is-open').find('.placeholder').text($(this).text());
  // console.log($(this).index())
});

// $('.wrap').on('click', '.placeholder', function(e) {
//   // e.preventDefault();
//   var parent = $('.select').closest('.select');
//   parent.removeClass('is-open');
//    console.log('wrap')

// })
$('.select').parent().mouseleave(function(){
  $('.select').removeClass('is-open');
})